export enum EntityType {
  Company = 'Company',
  GovernmentalInstitution = 'GovernmentalInstitution',
  NGO = 'NGO',
  PublicInstitution = 'PublicInstitution',
  Unknown = 'Unknown',
}

export const EntityTypeDescriptor = Object.freeze({
  [EntityType.Company]: 'Company',
  [EntityType.GovernmentalInstitution]: 'Governmental Institution',
  [EntityType.NGO]: 'NGO',
  [EntityType.PublicInstitution]: 'Public Institution',
  [EntityType.Unknown]: 'Unknown',
});
